var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin":"0 0 50px 0"}},[_c('userChat',{key:_vm.$i18n.locale,attrs:{"user":_vm.$route.params.user,"form":_vm.data.form,"entryID":_vm.data.md5ID}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }